import React from 'react';

import * as Styles from '../styles';
import * as S from './styles';

function FieldChecks({ options = [], label, ...rest }) {
    const optionsPerLine = Math.ceil(options.length / 2);

    const percentWidth = 100 / optionsPerLine;

    return (
        <Styles.Container {...rest}>
            <Styles.Label>{label}</Styles.Label>
            <S.InputContainer>
                {options.map((option) => (
                    <S.Check percentWidth={percentWidth}>
                        <S.Square checked={!!option.checked} />
                        <S.Label>{option.label}</S.Label>
                    </S.Check>
                ))}
            </S.InputContainer>
        </Styles.Container>
    );
}
export default FieldChecks;
